import React from 'react'
import "../../assets/css/loader.css";

const Loader = () => {
    return (
        <div className="load-bar">
            <div className="bar-item"></div>
            <div className="bar-item"></div>
            <div className="bar-item"></div>
        </div>
    )
}

export default Loader